import { AhamoveAdress } from "./ahamoveAdress.model";
import { AhamoveItems } from "./AhamoveItems.model";
import { AssignDeliveryModel } from "./assignDelivery.model";

export class ShipmentPartner{
    id:any;
    partnerId:any;
    addressNoteTo:string;
    addressNoteFrom:string;
    latTo:any
    lngTo:any;
    serviceId:string;
    paymentMethod:string;
    promoCode:string;
    remarks:string;
    orderTime:string;
    items:AhamoveItems[]=[];
    path:AhamoveAdress[]=[];
    shipmentBoxs:AssignDeliveryModel[]=[]
}